import { RestaurantPublicMenu } from '@localina/core';
import React, { useEffect, useMemo } from 'react';
import { IApplicationStore, IRestaurantPublicMenu } from '../../interfaces';
import * as actions from '../../store/restaurant/restaurant-actions';
import { connect } from 'react-redux';
import { useApp } from '../../contexts';

const Menu = (props: IProps) => {
    const { restaurantId } = useApp();

    useEffect(() => {
        props.requestRestaurantMenu(restaurantId);
    }, []);

    const menuConfiguration = useMemo(() => {
        if (props.menu) {
            const { dates: menu, ...other } = props.menu;
            return { ...other, menu };
        } else {
            return undefined;
        }
    }, [props.menu]);

    return (
        <div className={'restaurant-public-menu-container'}>
            <RestaurantPublicMenu menuConfiguration={menuConfiguration} />
        </div>
    );
};

interface IStoreProps {
    menu?: IRestaurantPublicMenu;
    isLoading: boolean;
}

interface IActionProps {
    requestRestaurantMenu: typeof actions.restaurantMenuRequested;
}

type IProps = IStoreProps & IActionProps;
const mapStateToProps = (state: IApplicationStore): IStoreProps => ({
    menu: state.restaurant.menu,
    isLoading: state.restaurant.isLoading,
});

const actionProps: IActionProps = {
    requestRestaurantMenu: actions.restaurantMenuRequested,
};

export default connect(mapStateToProps, actionProps)(Menu);
